import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import devicesReducer from "../features/devices/devicesSlice";
import telemetryReducer from "../features/telemetry/telemetrySlice";
import settingsReducer from "../features/settings/settingsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    devices: devicesReducer,
    telemetry: telemetryReducer,
    settings: settingsReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});
